<div #loginForm style="display: none">
    <div class="row">
        <div class="col-md-12" style="margin: 0 auto">
            <span>{{'TRANS_REMOTE_LOGIN.TRANS_CONNECT_WITH' | translate}}:</span>
            <div class="m-b-10 m-t-10">
                <app-social-login (validationOutput)="socialValidation($event)"></app-social-login>
            </div>
            <div>{{'TRANS_REMOTE_LOGIN.TRANS_OR_LOGIN' | translate}}:</div>
            <input type="text" id="username" class="swal2-input loginInput m-t-5"
                   style="margin-top: 6px; margin-bottom: 17px;"
                   placeholder="{{'TRANS_REMOTE_LOGIN.TRANS_USERNAME' | translate}}">
            <input type="password" id="password" class="swal2-input loginInput" placeholder="{{'TRANS_REMOTE_LOGIN.TRANS_PASSWORD' | translate}}">
            <p class="text-danger" style="font-weight: 600;font-size: 1rem;" *ngIf="notAuthenticated">
                {{'TRANS_REMOTE_LOGIN.TRANS_ERROR' | translate}}
            </p>
        </div>
    </div>
</div>